import { apiRequest } from '@/lib/api-client';

export interface Approval {
  id: string;
  title: string;
  summary: string;
  kind: string;
  agentType: string;
  status: string;
  data: Record<string, unknown>;
  createdAt: string;
}

const base = (orgId: string) => `/api/v1/organizations/${orgId}/approvals`;

export const approvalsApi = {
  listPending: (orgId: string) => apiRequest<Approval[]>(base(orgId)),
  approve: (orgId: string, id: string) =>
    apiRequest<Approval>(`${base(orgId)}/${id}/approve`, { method: 'POST' }),
  reject: (orgId: string, id: string) =>
    apiRequest<Approval>(`${base(orgId)}/${id}/reject`, { method: 'POST' }),
};
